import { ReactComponent as CreatedForIcon } from '../assets/icons/subject-icon.svg';
import { PARAMS } from '../constants/pages';
import { CREATE_SURVEY_FIELD_NAMES } from '../constants/survey';
import { prepareSurveyData } from './fillSurveyUtils';
import { prepareFilterableUsers } from './uiUtils';
import { formatDate } from './dateUtils';
import { isArray, isArrayEmpty } from './helpers';

export const getSurveysHistoryPageFilters = (translations, allUsers) => {
  const { CREATED_FOR } = PARAMS;

  return [
    {
      id: CREATED_FOR,
      name: translations.filters.labels.createdFor,
      icon: CreatedForIcon,
      items: prepareFilterableUsers(allUsers),
    },
  ];
};

export const getSurveysHistoryTableHeaders = labels => [
  {
    id: 1,
    title: labels.title,
    rowKey: 'title',
    sortAs: 'title',
    isHighlighted: true,
    minWidth: 140,
    maxWidth: '1fr',
  },
  {
    id: 2,
    title: labels.attributesQuestionnaire,
    rowKey: 'attributes',
    isSortingDisabled: true,
    maxWidth: '1.5fr',
  },
  {
    id: 3,
    title: labels.subjects,
    rowKey: 'subjects',
    isSortingDisabled: true,
    maxWidth: '1fr',
  },
  {
    id: 4,
    title: labels.dateSent,
    rowKey: 'dateSent',
    sortAs: 'sent_at',
    minWidth: '160px',
    maxWidth: '1fr',
  },
];

export const prepareSurveysHistoryTableData = (
  surveys,
  renderTitle,
  renderAttributes,
  renderQuestionnaire,
  renderCreatedFor
) => {
  if (isArray(surveys) && !isArrayEmpty(surveys)) {
    return surveys.map(survey => {
      const surveyData = prepareSurveyData(survey);

      return {
        id: survey.id,
        title: renderTitle(survey),
        attributes: surveyData[CREATE_SURVEY_FIELD_NAMES.QUESTIONNAIRE]
          ? renderQuestionnaire(
              surveyData[CREATE_SURVEY_FIELD_NAMES.QUESTIONNAIRE]
            )
          : renderAttributes(surveyData.attributes),
        subjects: renderCreatedFor(survey.created_for),
        dateSent: formatDate(survey.sent_at),
        token: survey.token,
        surveyTitle: survey.title,
      };
    });
  }

  return [];
};
